var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.615 3.684a1 1 0 0 0-1.891-.018l-2.52 7.118-1.147 3.235a1 1 0 0 0 1.886.668l.91-2.57h3.465l.851 2.552a1 1 0 1 0 1.897-.632L7.988 10.8 5.615 3.684zm.037 6.434H3.56l1.077-3.042 1.014 3.042zm12.171-1.726a1 1 0 0 1 1 1v1.373H23a1 1 0 0 1 0 2H21.95c-.37 1.398-1.339 3.474-3.158 5.364.872.705 1.844 1.341 2.87 1.773a1 1 0 0 1-.776 1.843c-1.319-.555-2.537-1.375-3.598-2.264a14.5 14.5 0 0 1-4.326 2.291 1 1 0 0 1-.632-1.897 12.567 12.567 0 0 0 3.468-1.778c-1.046-1.073-1.833-2.104-2.265-2.768a1 1 0 1 1 1.677-1.09c.399.614 1.136 1.566 2.1 2.543 1.369-1.405 2.167-2.917 2.55-4.017h-7.214a1 1 0 1 1 0-2h4.176V9.392a1 1 0 0 1 1-1z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.6577d7ad2822b458e3fa380622eeb88f.svg";
export { ForwardRef as ReactComponent };